import { render, staticRenderFns } from "./VCardDlg.vue?vue&type=template&id=7f9fc1b2&scoped=true&"
import script from "./VCardDlg.vue?vue&type=script&lang=ts&"
export * from "./VCardDlg.vue?vue&type=script&lang=ts&"
import style0 from "./VCardDlg.vue?vue&type=style&index=0&id=7f9fc1b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9fc1b2",
  null
  
)

export default component.exports